// src/pages/Insights.js
import React from 'react';

export default function Insights() {
  return (
    <div style={{padding:16}}>
      <h2>Insights</h2>
      <p>Admin-only analytics (sessions, durations, pages). Coming online…</p>
    </div>
  );
}
